import { render, staticRenderFns } from "./FreeClinicDoctor.vue?vue&type=template&id=7aef3cec&scoped=true"
import script from "./FreeClinicDoctor.vue?vue&type=script&lang=js"
export * from "./FreeClinicDoctor.vue?vue&type=script&lang=js"
import style0 from "./FreeClinicDoctor.vue?vue&type=style&index=0&id=7aef3cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aef3cec",
  null
  
)

export default component.exports